const MonthlyBilling = ({ className, ...props }: any) => {
  return (
    <i className={`icon-monthly-billing ${className}`} {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="20"
        viewBox="0 0 22 20"
        fill="none">
        <path
          d="M15.9762 18.2976C15.7059 18.4198 15.4148 18.4898 15.1185 18.5038C14.1495 18.5527 12.7923 18.5952 11 18.5952C9.20767 18.5952 7.85052 18.5523 6.88152 18.5034C6.5852 18.4895 6.29418 18.4196 6.02381 18.2976M18.0119 15.8262C17.6658 16.0485 17.2674 16.176 16.8565 16.1963C15.5953 16.265 13.674 16.3329 11 16.3329C8.32598 16.3329 6.40471 16.265 5.14348 16.1963C4.73262 16.176 4.33424 16.0485 3.9881 15.8262M1.68005 11.9045C1.79133 13.0332 2.70152 13.8443 3.83474 13.9063C5.29186 13.9864 7.63519 14.0714 11 14.0714C14.3648 14.0714 16.7081 13.9864 18.1657 13.9063C19.2985 13.8443 20.2087 13.0332 20.32 11.9045C20.4159 10.9323 20.5 9.55983 20.5 7.73809C20.5 5.91635 20.4159 4.54383 20.32 3.57166C20.2087 2.44252 19.2985 1.63185 18.1653 1.56987C16.7081 1.4898 14.3648 1.40475 11 1.40475C7.63519 1.40475 5.29186 1.4898 3.83429 1.56987C2.70152 1.63185 1.79133 2.44297 1.68005 3.57166C1.58414 4.54428 1.5 5.91635 1.5 7.73809C1.5 9.55983 1.58414 10.9323 1.68005 11.9045Z"
          stroke="#878787"
          stroke-width="1.35714"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.8095 5.7069C12.8095 5.7069 12.0857 5.15273 11 5.15273C10.0952 5.15273 9.19048 5.7069 9.19048 6.44518C9.19048 8.2918 12.8095 7.18392 12.8095 9.03054C12.8095 9.76883 11.9048 10.323 11 10.323M11 10.323C9.91429 10.323 9.19048 9.76883 9.19048 9.76883M11 10.323V11.3571M11 5.15318V4.11904M16.881 7.73809H16.4286M5.57143 7.73809H5.11905"
          stroke="#878787"
          stroke-width="1.35714"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </i>
  )
}

export default MonthlyBilling
